module.exports = __webpack_public_path__ + "static/media/uploadFile.64462b77.svg";